import React from 'react';
import styled from 'styled-components';

const NavigationWrapper = styled.div`
  /* flex: 1 1 auto; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: 100%; */
  z-index: 1;
  box-shadow: 0px -1px 20px -6px rgba(0, 0, 0, 0.2),
    0px 1px 20px -6px rgba(0, 0, 0, 0.2);
  height: auto;
  min-height: 285px;
  background: ${props => props.theme.colors.lightgray};
  align-self: flex-start;
  margin-top: 15px;
`;

const NavigationItemsWrapper = styled.div`
  flex-direction: column;
  /* flex: 1 1 auto; */
  overflow-y: auto;
`;

const Navigation = ({ children }) => {
  return (
    <NavigationWrapper>
      <NavigationItemsWrapper>{children}</NavigationItemsWrapper>
    </NavigationWrapper>
  );
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js